import Button from "../../../componentsNew/Button";
import { CampoInputBase } from "../../../componentsNew/Input/CampoInput/CampoInputBase";
import HeaderTable from "../../../componentsNew/Table/HeaderTable";
import ItemTable from "../../../componentsNew/Table/ItemTable";
import Typography from "../../../componentsNew/Typography";
import star from "../../../assets/img/stars-02.svg"
import Card from "../../../componentsNew/Card";
import Select from "../../../componentsNew/Select";
import { IoIosArrowDown } from "react-icons/io";

export function StepEstruturaTexto({ form, mudarValor }) {
    return (
        <>
            <Card className="px-4 py-3 text-center !shadow-[0px_5px_4px_0px_rgba(0,0,0,0.20)]">
                <Typography component="body-secundary-bold">Configure a estrutura do texto para geração.</Typography>
            </Card>

            <Select
                className="mt-8"
                component="active"
                valorInput={form.tamanhoTexto}
                setValorInput={e => mudarValor("tamanhoTexto", e)}
                label="Tamanho do texto"
                icon={<IoIosArrowDown className="w-4 text-text-secundary" />}
                opcoes={[
                    { valor: 'SMALL', titulo: 'Pequeno (500-1000 Palavras)' },
                    { valor: 'MEDIUM', titulo: 'Médio (1000-2000 Palavras)' },
                    { valor: 'LARGE', titulo: 'Grande (2000-3000 Palavras)' },
                    { valor: 'XLARGE', titulo: 'Extra Grande (3000-5000 Palavras)' },
                ]}
            //carregando={carregando}
            //desabilidato={desabilidato}
            //renderValue={renderValue}
            //checkbox={checkbox} 
            />
        </>
    )
}